import gsap from 'gsap';
import appStore from '../utils/state';

export default class MainDesktopOverlay extends HTMLElement {
  private showTl: gsap.core.Timeline | null = null;
  private hideTl: gsap.core.Timeline | null = null;

  private isVisible: boolean = false;
  private isOver: boolean = false;

  private unsubscribeFromFiltersModalState: (() => void) | null = null;
  private unsubscribeFromSizeSelectorModalState: (() => void) | null = null;
  private unsubscribeFromQuickBuyModalState: (() => void) | null = null;
  private unsubscribeFromCartModalState: (() => void) | null = null;
  private unsubscribeFromDetailsAndCareModalState: (() => void) | null = null;
  private unsubscribeFromSizeAndFitModalState: (() => void) | null = null;
  private unsubscribeFromSustainabilityModalState: (() => void) | null = null;
  private unsubscribeFromDeliveryAndReturnsModalState: (() => void) | null = null;
  private unsubscribeFromOutOfStockModalState: (() => void) | null = null;
  private unsubscribeFromDescriptionModalState: (() => void) | null = null;
  private unsubscribeFromGiftcardInstructionsModalState: (() => void) | null = null;
  private unsubscribeFromGiftcardWarningModalState: (() => void) | null = null;
  private unsubscribeFromShopTheLookModalState: (() => void) | null = null;

  private onShopTheLookModalToggleBound = this.onShopTheLookModalToggle.bind(this);
  private onClickBound = this.onClick.bind(this);
  private onFiltersModalToggleBound = this.onFiltersModalToggle.bind(this);
  private onSizeSelectorModalToggleBound = this.onSizeSelectorModalToggle.bind(this);
  private onQuickBuyModalToggleBound = this.onQuickBuyModalToggle.bind(this);
  private onCartModalToggleBound = this.onCartModalToggle.bind(this);
  private onDetailsAndCareModalToggleBound = this.onDetailsAndCareModalToggle.bind(this);
  private onSizeAndFitModalToggleBound = this.onSizeAndFitModalToggle.bind(this);
  private onSustainabilityModalToggleBound = this.onSustainabilityModalToggle.bind(this);
  private onDeliveryAndReturnsModalToggleBound = this.onDeliveryAndReturnsModalToggle.bind(this);
  private onOutOfStockModalToggleBound = this.onOutOfStockModalToggle.bind(this);
  private onDescriptionModalToggleBound = this.onDescriptionModalToggle.bind(this);
  private onGiftcardInstructionsModalToggleBound = this.onGiftcardInstructionsModalToggle.bind(this);
  private onGiftcardWarningModalToggleBound = this.onGiftcardWarningModalToggle.bind(this);

  connectedCallback(): void {
    this.addEventListeners();
    this.subscribe();
  }

  addEventListeners(): void {
    this.addEventListener('click', this.onClickBound);
  }

  removeEventListeners(): void {
    this.removeEventListener('click', this.onClickBound);
  }

  subscribe(): void {
    this.unsubscribeFromFiltersModalState = appStore.subscribeKey('isFiltersModalOpen', this.onFiltersModalToggleBound);
    this.unsubscribeFromSizeSelectorModalState = appStore.subscribeKey(
      'isSizeSelectorModalOpen',
      this.onSizeSelectorModalToggleBound,
    );
    this.unsubscribeFromQuickBuyModalState = appStore.subscribeKey(
      'isQuickBuyModalOpen',
      this.onQuickBuyModalToggleBound,
    );
    this.unsubscribeFromCartModalState = appStore.subscribeKey('isCartModalOpen', this.onCartModalToggleBound);
    this.unsubscribeFromDetailsAndCareModalState = appStore.subscribeKey(
      'isDetailsAndCareModalOpen',
      this.onDetailsAndCareModalToggleBound,
    );
    this.unsubscribeFromSizeAndFitModalState = appStore.subscribeKey(
      'isSizeAndFitModalOpen',
      this.onSizeAndFitModalToggleBound,
    );
    this.unsubscribeFromSustainabilityModalState = appStore.subscribeKey(
      'isSustainabilityModalOpen',
      this.onSustainabilityModalToggleBound,
    );
    this.unsubscribeFromDeliveryAndReturnsModalState = appStore.subscribeKey(
      'isDeliveryAndReturnsModalOpen',
      this.onDeliveryAndReturnsModalToggleBound,
    );
    this.unsubscribeFromOutOfStockModalState = appStore.subscribeKey(
      'isOutOfStockModalOpen',
      this.onOutOfStockModalToggleBound,
    );
    this.unsubscribeFromDescriptionModalState = appStore.subscribeKey(
      'isDescriptionModalOpen',
      this.onDescriptionModalToggleBound,
    );
    this.unsubscribeFromGiftcardInstructionsModalState = appStore.subscribeKey(
      'isGiftcardInstructionsModalOpen',
      this.onGiftcardInstructionsModalToggleBound,
    );
    this.unsubscribeFromGiftcardWarningModalState = appStore.subscribeKey(
      'isGiftcardWarningModalOpen',
      this.onGiftcardWarningModalToggleBound,
    );
    this.unsubscribeFromShopTheLookModalState = appStore.subscribeKey(
      'isShopTheLookModalOpen',
      this.onShopTheLookModalToggleBound,
    );
  }

  unsubscribe(): void {
    if (this.unsubscribeFromFiltersModalState) {
      this.unsubscribeFromFiltersModalState();
      this.unsubscribeFromFiltersModalState = null;
    }
    if (this.unsubscribeFromCartModalState) {
      this.unsubscribeFromCartModalState();
      this.unsubscribeFromCartModalState = null;
    }
    if (this.unsubscribeFromSizeSelectorModalState) {
      this.unsubscribeFromSizeSelectorModalState();
      this.unsubscribeFromSizeSelectorModalState = null;
    }
    if (this.unsubscribeFromQuickBuyModalState) {
      this.unsubscribeFromQuickBuyModalState();
      this.unsubscribeFromQuickBuyModalState = null;
    }
    if (this.unsubscribeFromDetailsAndCareModalState) {
      this.unsubscribeFromDetailsAndCareModalState();
      this.unsubscribeFromDetailsAndCareModalState = null;
    }
    if (this.unsubscribeFromSizeAndFitModalState) {
      this.unsubscribeFromSizeAndFitModalState();
      this.unsubscribeFromSizeAndFitModalState = null;
    }
    if (this.unsubscribeFromSustainabilityModalState) {
      this.unsubscribeFromSustainabilityModalState();
      this.unsubscribeFromSustainabilityModalState = null;
    }
    if (this.unsubscribeFromDeliveryAndReturnsModalState) {
      this.unsubscribeFromDeliveryAndReturnsModalState();
      this.unsubscribeFromDeliveryAndReturnsModalState = null;
    }
    if (this.unsubscribeFromOutOfStockModalState) {
      this.unsubscribeFromOutOfStockModalState();
      this.unsubscribeFromOutOfStockModalState = null;
    }
    if (this.unsubscribeFromDescriptionModalState) {
      this.unsubscribeFromDescriptionModalState();
      this.unsubscribeFromDescriptionModalState = null;
    }
    if (this.unsubscribeFromGiftcardInstructionsModalState) {
      this.unsubscribeFromGiftcardInstructionsModalState();
      this.unsubscribeFromGiftcardInstructionsModalState = null;
    }
    if (this.unsubscribeFromGiftcardWarningModalState) {
      this.unsubscribeFromGiftcardWarningModalState();
      this.unsubscribeFromGiftcardWarningModalState = null;
    }
    if (this.unsubscribeFromShopTheLookModalState) {
      this.unsubscribeFromShopTheLookModalState();
      this.unsubscribeFromShopTheLookModalState = null;
    }
  }

  onClick(): void {
    if (appStore.getState().isGiftboxModalOpen) {
      appStore.actions.closeGiftboxModal();
    } else if (appStore.getState().isOutOfStockModalOpen) {
      appStore.actions.closeOutOfStockModal();
    } else {
      appStore.actions.closeFiltersModal();
      appStore.actions.closeSizeSelectorModal();
      appStore.actions.closeQuickBuyModal();
      appStore.actions.closeCartModal();
      appStore.actions.closeDetailsAndCareModal();
      appStore.actions.closeSizeAndFitModal();
      appStore.actions.closeSustainabilityModal();
      appStore.actions.closeDeliveryAndReturnsModal();
      appStore.actions.closeDescriptionModal();
      appStore.actions.closeGiftcardInstructionsModal();
      appStore.actions.closeGiftcardWarningModal();
      appStore.actions.closeShopTheLookModal();
    }
  }

  onFiltersModalToggle(): void {
    const isFiltersModalOpen = appStore.getState().isFiltersModalOpen;

    if (isFiltersModalOpen) {
      this.show();
    } else {
      this.hide();
    }
  }

  onSizeSelectorModalToggle(): void {
    const isSizeSelectorModalOpen = appStore.getState().isSizeSelectorModalOpen;

    if (isSizeSelectorModalOpen) {
      this.show();
    } else {
      this.hide();
    }
  }

  onQuickBuyModalToggle(): void {
    const isQuickBuyModalOpen = appStore.getState().isQuickBuyModalOpen;

    if (isQuickBuyModalOpen) {
      this.show();
    } else {
      if (!appStore.getState().isCartModalOpen) {
        this.hide();
      }
    }
  }

  onCartModalToggle(): void {
    const isCartModalOpen = appStore.getState().isCartModalOpen;

    if (isCartModalOpen) {
      this.show();
    } else {
      this.hide();
    }
  }

  onDetailsAndCareModalToggle(): void {
    const isDetailsAndCareModalOpen = appStore.getState().isDetailsAndCareModalOpen;

    if (isDetailsAndCareModalOpen) {
      this.show();
    } else {
      this.hide();
    }
  }

  onSizeAndFitModalToggle(): void {
    const isSizeAndFitModalOpen = appStore.getState().isSizeAndFitModalOpen;

    if (isSizeAndFitModalOpen) {
      this.show();
    } else {
      this.hide();
    }
  }

  onSustainabilityModalToggle(): void {
    const isSustainabilityModalOpen = appStore.getState().isSustainabilityModalOpen;

    if (isSustainabilityModalOpen) {
      this.show();
    } else {
      this.hide();
    }
  }

  onDeliveryAndReturnsModalToggle(): void {
    const isDeliveryAndReturnsModalOpen = appStore.getState().isDeliveryAndReturnsModalOpen;

    if (isDeliveryAndReturnsModalOpen) {
      this.show();
    } else {
      this.hide();
    }
  }

  onOutOfStockModalToggle(): void {
    // Dimming handled by out-of-stock dialog ::backdrop (top layer).
  }

  onDescriptionModalToggle(): void {
    const isDescriptionModalOpen = appStore.getState().isDescriptionModalOpen;

    if (isDescriptionModalOpen) {
      this.show();
    } else {
      this.hide();
    }
  }

  onGiftcardInstructionsModalToggle(): void {
    const isGiftcardInstructionsModalOpen = appStore.getState().isGiftcardInstructionsModalOpen;

    if (isGiftcardInstructionsModalOpen) {
      this.show();
    } else {
      this.hide();
    }
  }

  onGiftcardWarningModalToggle(): void {
    const isGiftcardWarningModalOpen = appStore.getState().isGiftcardWarningModalOpen;

    if (isGiftcardWarningModalOpen) {
      this.show();
    } else {
      this.hide();
    }
  }

  onShopTheLookModalToggle(): void {
    const isShopTheLookModalOpen = appStore.getState().isShopTheLookModalOpen;

    if (isShopTheLookModalOpen) {
      this.show();
    } else {
      this.hide();
    }
  }

  show(isOver: boolean = false): void {
    if (this.hideTl) {
      this.hideTl.kill();
    }
    if (this.showTl) {
      this.showTl.kill();
    }

    this.isOver = isOver;

    this.showTl = gsap.timeline();
    if (this.isVisible == false) {
      this.showTl.set([window.document.body], { overflow: 'hidden' }, 0);
      this.showTl.fromTo(this, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.5, ease: 'power2.out' }, 0);
    }

    if (isOver) {
      this.classList.remove('overlay-z-index');
      this.classList.add('over-overlay-z-index');
    } else {
      this.classList.remove('over-overlay-z-index');
      this.classList.add('overlay-z-index');
    }

    this.isVisible = true;
  }

  hide(): void {
    if (this.showTl) {
      this.showTl.kill();
    }
    if (this.hideTl) {
      this.hideTl.kill();
    }
    this.hideTl = gsap.timeline();

    if (this.isOver) {
      this.classList.remove('over-overlay-z-index');
      this.classList.add('overlay-z-index');
    } else {
      this.hideTl.set([window.document.body], { clearProps: 'overflow' }, 0);
      this.hideTl.to(this, { autoAlpha: 0, duration: 0.2, ease: 'power2.out' }, 0);

      this.isVisible = false;
    }

    this.isOver = false;
  }

  disconnectedCallback(): void {
    this.unsubscribe();
    this.removeEventListeners();

    if (this.showTl) {
      this.showTl.kill();
    }
    if (this.hideTl) {
      this.hideTl.kill();
    }
  }
}

customElements.define('main-desktop-overlay', MainDesktopOverlay);
